export let classList = [
  {
    label: "小学",
    value: [
      {
        label: "一年级",
        value: [
          {
            label: "语文",
            text: "学习声母、韵母、声调、拼音拼写、汉字书写，学会阅读小篇章及如何看图说话。"
          },
          {
            label: "数学",
            text: "学习100以内加减法、立体图形、平面图形、分类与整理、单数与双数等。"
          },
          {
            label: "英语",
            text: "学习字母、短元音、辅音等自然拼读，初步培养听力口语能力。"
          }
        ]
      },
      {
        label: "二年级",
        value: [
          {
            label: "语文",
            text: "学习字词、组词、古诗、口语交际、造句等知识，进一步学习小篇章阅读及看图说话。"
          },
          {
            label: "数学",
            text: "学习简单的乘除法、乘除法应用题、单位长度、图形的运动、数据整理和收集等。"
          },
          {
            label: "英语",
            text: "学习字母、短元音、辅音、长元音、字母组合等自然拼读，加强听力口语能力的培养。"
          }
        ]
      },
      {
        label: "三年级",
        value: [
          {
            label: "语文",
            text: "学习字词、组词、反义词、同音词辨析等知识，学会阅读小短文，按要求写作文。"
          },
          {
            label: "数学",
            text: "学习万以内加减法、倍数和除法应用题、计数法和统计图、周长和面积、可能性等。"
          },
          {
            label: "英语",
            text: "学习自然拼读，了解名词、形容词、冠词、动词以及生活用语，培养听力口语能力。"
          }
        ]
      },
      {
        label: "四年级",
        value: [
          {
            label: "语文",
            text: "学习字词、成语、古诗、课文、短文阅读及如何写简单的记叙文。"
          },
          {
            label: "数学",
            text: "学习两/三位数的乘除法、小数加减法、行程问题、应用题、多边形、面积、统计图等。"
          },
          {
            label: "英语",
            text: "学习名词、形容词、冠词、介词、情态动词、动词时态等知识，培养听力口语能力。"
          }
        ]
      },
      {
        label: "五年级",
        value: [
          {
            label: "语文",
            text: "学习字词、成语、诗句、短文阅读，学习如何写读后感、看图作文、缩写、梗概等。"
          },
          {
            label: "数学",
            text: "学习小数乘除法、分数加减法、多边形、可能性、质数与合数、因数与倍数、应用题等。"
          },
          {
            label: "英语",
            text: "学习时间介词、情态动词、否定词、不规则动词、一般过去时、过去进行时等。"
          }
        ]
      },
      {
        label: "六年级",
        value: [
          {
            label: "语文",
            text: "学习口语交际、诗歌朗诵、文言文、文学常识、阅读，学习如何写演讲稿、建议书等。"
          },
          {
            label: "数学",
            text: "学习分数乘除法、混合运算、圆与扇形、圆柱与圆锥、统计图、分数应用题、经济问题等。"
          },
          {
            label: "英语",
            text: "学习名词、数词、冠词、介词、代词、动词的相关知识，最后进行梳理与串讲。"
          }
        ]
      }
    ]
  },
  {
    label: "初中",
    value: [
      {
        label: "初一",
        value: [
          {
            label: "语文",
            text: "学习对联、书法等基础知识，阅读并分析文言文、名著、现代文，学习基本写作思路。"
          },
          {
            label: "数学",
            text: "学习有理数、整式加减、一元一次方程、图形认识与初步、相交线与平行线等。"
          },
          {
            label: "英语",
            text: "学习国际音标、26个字母、基础语法、基础话题写作、听口基础知识，扩充阅读词汇量。"
          },
          {
            label: "生物",
            text: "学习科学探究、细胞是生命活动的基本单位、生物的结构层次、生物和环境等。"
          },
          {
            label: "历史",
            text: "学习中华文明的起源、封建国家的分裂和民族融合、贞观之治到开元盛世等。"
          },
          {
            label: "地理",
            text: "学习地球和地图、陆地和海洋、天气与气候、居民与聚落、世界地理等。"
          },
          {
            label: "政治",
            text: "学习如何与人交往相处、如何正确认知青春期身体的改变以及法律的重要性。"
          }
        ]
      },
      {
        label: "初二",
        value: [
          {
            label: "语文",
            text: "学习传统文化、文言文，学习如何阅读和分析名著、如何赏析现代文及写作基本思路。"
          },
          {
            label: "数学",
            text: "学习全等三角形、轴对称、整式乘法与因式分解、分式、二次根式、平行四边形等。"
          },
          {
            label: "英语",
            text: "学习词汇、语法、写作思路和常用句式，练习阅读、选词填空和听口考试的四大题型。"
          },
          {
            label: "物理",
            text: "学习机械运动、声现象、物态变化、光现象与透镜的应用、质量密度、运动和力等。"
          },
          {
            label: "生物",
            text: "学习无脊椎动物不同类群、脊椎动物不同类群、动物的运动和行为、真菌和病毒等。"
          },
          {
            label: "历史",
            text: "学习侵略与反抗和近代化的探索、新民主主义革命的兴起、抗日战争和解放战争等。"
          },
          {
            label: "地理",
            text: "学习中国的概况、中国的自然环境、中国的经济环境、中国四大分区的知识。"
          },
          {
            label: "政治",
            text: "学习社会规则、国家利益和国家安全的意义、国家发展的历史和现状以及如何运用法律。"
          }
        ]
      },
      {
        label: "初三",
        value: [
          {
            label: "语文",
            text: "学习文言文句式、文言现象、现代文阅读的解题方法、写作思路和方法，复习名著知识点。"
          },
          {
            label: "数学",
            text: "学习二次函数、反比例函数、相似、三角函数等知识，一轮复习二次函数、三角等。"
          },
          {
            label: "英语",
            text: "学习中考词汇、写作常用句型、阅读的行文思路和结构，复习语法，讲练听口考试题型。"
          },
          {
            label: "物理",
            text: "学习内能及其应用、电学基础、欧姆定律、电功与电功率、家庭电路与用电安全等。"
          },
          {
            label: "化学",
            text: "学习常见的物质、化学与生活、化学反应及反应原理、物质的推断、科学与探究等。"
          },
          {
            label: "生物",
            text: "学习生物体的结构层次、生物与环境、生物圈中的绿色植物、生物圈中的人等。"
          },
          {
            label: "历史",
            text: "学习人类的起源和早期文明的发展、资本主义的产生、发展和国家的建立等。"
          },
          {
            label: "地理",
            text: "学习世界地理基本概况、世界地理、中国地理、中国的四大分区等。"
          },
          {
            label: "政治",
            text: "学习责任和奉献的意义、基本国策和战略，了解我国政治、经济及文化发展。"
          }
        ]
      }
    ]
  },
  {
    label: "高中",
    value: [
      {
        label: "高一",
        value: [
          {
            label: "语文",
            text: "学习文言文虚词、实词、句式，分析小说情节、人物，学习名著以及记叙文写作。"
          },
          {
            label: "数学",
            text: "学习向量、三角函数、解三角形、概率与统计、立体几何、直线和圆。"
          },
          {
            label: "英语",
            text: "学习语法、必备单词、阅读理解四大题型与四大文本、基本句型、常用词汇及优秀作文。"
          },
          {
            label: "物理",
            text: "学习直线运动、相互作用、牛顿运动定律、曲线运动、功和能、动量守恒定律、实验。"
          },
          {
            label: "化学",
            text: "学习化学计量与实验、物质分类与离子反应、氧化还原、金属元素、非金属元素。"
          },
          {
            label: "生物",
            text: "学习组成细胞的分子与化合物、细胞的结构组成、细胞内的物质运输、酶与ATP等。"
          },
        ]
      },
      {
        label: "高二",
        value: [
          {
            label: "语文",
            text: "学习、分析古代诗歌、名著《三国演义》以及散文，学习写议论文的思路和方法。"
          },
          {
            label: "数学",
            text: "学习数列、不等式、常用逻辑、圆锥曲线、空间向量与立体几何、导数、复数等。"
          },
          {
            label: "英语",
            text: "学习语法、常用写作句型，讲解完形、阅读理解四大题型与四大文本，二轮记忆高考词。"
          },
          {
            label: "物理",
            text: "学习静电场、恒定电流、磁场、电磁感应和交变电流、机械振动和机械波、热学等。"
          },
          {
            label: "化学",
            text: "学习化学反应与能量、化学反应速率和化学平衡、水溶液中的离子平衡、电化学基础等。"
          },
          {
            label: "生物",
            text: "学习内环境及稳态、神经调节、体液调节、免疫调节、植物激素、种群群落、生态系统等。"
          },
        ]
      },
      {
        label: "高三",
        value: [
          {
            label: "语文",
            text: "学习文言文虚词、实词、句式和散文题，分析名著人物，学习运用写作表达自己的思想。"
          },
          {
            label: "数学",
            text: "进行一轮复习和二轮复习，内容包含集合与简易逻辑、函数、导数、三角函数、不等式等。"
          },
          {
            label: "英语",
            text: "纠正发音、语法和做题思路上的错误，复习高考语法点，最后一轮记忆高考词，积累好词。"
          },
          {
            label: "物理",
            text: "学习力学、电磁学、机械振动、机械波、交变电流、热学、光学、原子物理、实验等。"
          },
          {
            label: "化学",
            text: "学习化学基本概念、元素化合物、反应原理、机化学、化学实验。"
          },
          {
            label: "生物",
            text: "学习细胞组成与结构、细胞代谢、细胞分裂与生命历程、遗传规律、遗传的分子基础等。"
          },
          {
            label: "历史",
            text: "学习中国先秦时期政治、经济、文化科技，中国秦汉时期政治、经济、文化科技等。"
          },
          {
            label: "地理",
            text: "学习地球与地图、行星地球、地球上的大气、地球上的水、地表形态的塑造、人口变化等。"
          },
          {
            label: "政治",
            text: "学习社会主义市场经济、为人民服务的政府、中华文化与民族精神、联系观。"
          },
        ]
      }
    ]
  },
]